export default __webpack_public_path__ + "images/17ba01bf6a9aa30658e9af93c1f8ad28-foodPlaceholder.png";